import CoursePage from './CoursePage';
import useEvents from '../../hooks/useEvents';

export default function WorkshopsPage() {
  const { events, loading } = useEvents('workshop');
  return (
    <CoursePage courses={events} loading={loading} pageTitle={'Workshops'} category={'workshop'} />
  );
}
